import { render } from "./AdFormatFilterBody.vue?vue&type=template&id=ec949912"
import script from "./AdFormatFilterBody.vue?vue&type=script&lang=js"
export * from "./AdFormatFilterBody.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__